import React from "react";
import { STAGES, stageIndex } from "@/lib/constants";
import { Check } from "lucide-react";

export default function JourneyStepper({ current, testId = "journey-stepper" }) {
  const idx = stageIndex(current);
  return (
    <div data-testid={testId} className="w-full">
      <div className="flex items-center gap-2 md:gap-3 overflow-x-auto pb-2">
        {STAGES.map((s, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <React.Fragment key={s}>
              <div
                data-testid={`stage-${i + 1}`}
                className={
                  "flex items-center gap-2 whitespace-nowrap rounded-full border px-3 py-1.5 text-xs md:text-sm transition-colors duration-200 " +
                  (active
                    ? "border-primary bg-primary text-primary-foreground"
                    : done
                    ? "border-primary/40 bg-primary/10 text-primary"
                    : "border-border bg-white text-muted-foreground")
                }
              >
                <span
                  className={
                    "flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold " +
                    (active
                      ? "bg-white text-primary"
                      : done
                      ? "bg-primary text-white"
                      : "bg-muted text-foreground/60")
                  }
                >
                  {done ? <Check className="h-3 w-3" /> : i + 1}
                </span>
                <span className="font-medium">{s}</span>
              </div>
              {i < STAGES.length - 1 && (
                <div className={"h-px w-4 md:w-8 " + (i < idx ? "bg-primary/40" : "bg-border")} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
